export default __webpack_public_path__ + "static/8ball.21265f7a38cf667eee74bc272bef1f63.png";